import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import queryString from "query-string";
import { Helmet } from "react-helmet";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import SleevesByTagContainer from "~/Components/Containers/SleevesByTagContainer";
import SleeveResult from "~/Components/SleeveResult";
import Pager from "../../Components/Global/Pager";

const TagListPage = ({ match, location }) => {
  const paramTag = match.params.tag;

  let history = useHistory();
  const queryStringParams = queryString.parse(location.search);
  const { page: startPage = 1 } = queryStringParams;
  const [page, setPage] = useState(parseInt(startPage, 10));
  const [tag, setTag] = useState(paramTag);
  const updatePageCallBack = (toPage) => {
    history.push("?page=" + page);
    setPage(toPage);
  };
  return (
    <div className="page-home">
      <Helmet>
        <title>Sleevery | Sleeves: {tag} | Dream Chimney</title>
      </Helmet>
      <Row>
        <Col xs={12}>
          <h1 className="page-header">
            <i className="fa fa-tags"></i> Sleeves: {tag}
          </h1>
        </Col>
        <Col xs={12}>
          <SleevesByTagContainer
            find={tag}
            page={page}
            render={({ result }) => {
              const { sleeves, perPage, total } = result;
              const pages = Math.ceil(total / perPage);

              if (sleeves.length === 0) return null;
              return (
                <Row>
                  <Col xs={12}>
                    <ul className="results cover-list">
                      {sleeves.map((sleeve) => (
                        <li key={sleeve.id}>
                          <SleeveResult sleeve={sleeve} />
                        </li>
                      ))}
                    </ul>
                  </Col>

                  <Col xs={12}>
                    <div style={{ padding: "20px 0" }}>
                      <Pager className="pagination-footer" page={page} pages={pages} updatePage={updatePageCallBack} />
                    </div>
                  </Col>
                </Row>
              );
            }}
          />
        </Col>
      </Row>
    </div>
  );
};

export default TagListPage;
